function isPolygonClosed(poly) {
    if (poly.length < 3)
        return false;
    const first = poly[0];
    const last = poly[poly.length - 1];
    if ('x' in first) {
        const lastVector3 = last;
        if (first.x !== lastVector3.x)
            return false;
        if (first.y !== lastVector3.y)
            return false;
        if (first.z !== lastVector3.z)
            return false;
    }
    else {
        const lastV3 = last;
        if (first[0] !== lastV3[0])
            return false;
        if (first[1] !== lastV3[1])
            return false;
        if (first[2] !== lastV3[2])
            return false;
    }
    return true;
}

export { isPolygonClosed };
//# sourceMappingURL=is-polygon-closed.js.map
